import React, { useEffect } from "react";
import Header from "../../components/layout/Header";
import Hero from "../../components/accomodation/hero/Hero";
import { IMAGES } from "../../data/images";
import Footer from "../../components/layout/Footer";
import Faq from "../../components/accomodation/faq/Faq";
import Working from "../../components/accomodation/working/Working";
import Program from "../../components/scholarship/program/Program";
import { FAQS } from "../../data/faqs";

const workingdata = [
  {
    heading: "Profile Assessment",
    description:
      "Submit your details including name, contact, and academic background. Our counsellors will assess your profile and guide you through the scholarship application process.",
  },
  {
    heading: "Application Process",
    description:
      "Complete the Ever Sky Scholarship application form and submit a supporting essay demonstrating your candidature, academic merit, and financial need.",
  },
  {
    heading: "Interview & Review",
    description:
      "Shortlisted candidates attend an interview with our scholarship committee, who evaluate your application and make the final award decision.",
  },
  {
    heading: "Scholarship Award",
    description:
      "Winners are informed about the scholarship amount, program, and institution. Funds are disbursed directly to the university upon enrollment confirmation.",
  },
];

function Scholarship() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <Hero
        heading="Ever Sky Scholarship Program for Excellence"
        description="Make the most of scholarship opportunities to further your education abroad"
        img={IMAGES.scholarship}
      />
      <Program />
      <Working data={workingdata} />
      <Faq data={FAQS.scholarship} />
      <Footer />
    </>
  );
}

export default Scholarship;
